import React, {useState, useEffect} from 'react'

import "./Companies.css"
import TextField from '@mui/material/TextField';
import axios from 'axios';
import ValidationMessage from '../../shared/validationmessage/ValidationMessage';
import 'react-calendar/dist/Calendar.css';
import DatePicker from 'react-date-picker';

const model = {
  modulename: "Company Editor"
};

const CompanyEditor = (props) => {

  /* data handling */
  const data = props.data.data;
  const [Id, setId] = useState(data.Id);
  const [Address, setAddress] = useState(data.Address);
  const [Name, setName] = useState(data.Name);
  const [Industry, setIndustry] = useState(data.Industry);
  const [PhoneNumber, setPhoneNumber] = useState(data.PhoneNumber);
  const [UserLimit, setUserLimit] = useState(data.UserLimit);
  const [ValidityDate, setValidityDate] = useState(data.ValidityDate ? new Date(data.ValidityDate) : new Date());
  const [CanManageSituations, setCanManageSituations] = useState(data.CanManageSituations);
  const [CanAccess, setCanAccess] = useState(data.CanAccess);
  const [EnableVideos, setEnableVideos] = useState(data.EnableVideos);

  const [image, setImage] = useState(axios.defaults.baseURL + '/' + data.Logo);
  const [file, setFile] = useState();

  const[showCalender, setShowCalender] = useState(false)

  /* exceoption handling */
  const [validations, setValidations] = useState({
      Industry: [],
      Name: [],
      Address: [],
      PhoneNumber: [],
      UserLimit: [],
      ValidityDate: []
  });

  const resetValidations=()=>{
    setValidations({
      Industry: [],
      Name: [],
      Address: [],
      PhoneNumber: [],
      UserLimit: [],
      ValidityDate: []
    });
    props.setErrors("");
  }

  const parseErrorResponse=(response)=>{
    if(response.data.errors){
      props.setErrors("");
      setValidations(response.data.errors);
    }
  }

  const toggleCalenderView=()=>{
    setShowCalender(!showCalender);
  }

  const handleCancelClick = () => {
    props.setEditorState({open: false, data: null});
  };

  const handleSubmitClick =(e)=>{
    e.preventDefault();

    axios.post('/companies/save', {
      Id: Id,
      Name: Name,
      Address: Address,
      Industry: Industry,
      PhoneNumber: PhoneNumber,
      UserLimit: UserLimit,
      ValidityDate: ValidityDate,
      CanManageSituations: CanManageSituations,
      CanAccess: CanAccess,
      EnableVideos: EnableVideos
    })
    .then(function (response) {
      if(response.data.status == "success"){
        props.setErrors("")
        setId(response.Id);
        uploadFileToServer(response);
      }
      else{
        props.setErrors(response.data.message)
      }
    })
    .catch(function (error) {
      parseErrorResponse(error.response);
    });
  };

  const uploadFileToServer=(response)=>{
    if(file){
      const formData = new FormData();
      formData.append('Id', Id);
      formData.append('formFile', file);
      axios.post('/companies/upload', formData,{
        headers: {
          "Content-Type": "multipart/form-data",
        }
      })
      .then(function (response) {
        if(response.data.status == "success"){
          props.setEditorState({open: false, data: null});
          props.setPageState({loading: false});
        }
        else{
          props.setErrors(response.data.message);
        }
      })
      .catch(function (error) {
        props.setErrors(error.response.data.message);
      });
    }
    else{
      props.setEditorState({open: false, data: null});
      props.setPageState({loading: false});
    }
  }

  const handleFileChange =(e)=>{
    setImage(URL.createObjectURL(e.target.files[0]));
    setFile(e.target.files[0]);
  }

  return (
    <form className="form">
      <div className="mb-3">
          <img src={image} alt={Name} />
          <label className="upload-file">
          <input type="file" onChange={handleFileChange} className="d-none" /> Browser logo... </label>     
      </div>
      <div className="mb-3">
      <TextField
          required
          className="form-control"
          label="Name"
          value={Name}
          onChange={e=> setName(e.target.value)}
        />
        <ValidationMessage field="Name" errors={validations}/>
      </div>
      <div className="mb-3">
      <TextField
          className="form-control"
          label="Phone"
          value={PhoneNumber}
          onChange={e=> setPhoneNumber(e.target.value)}
        />
        <ValidationMessage field="PhoneNumber" errors={validations}/>
      </div>
      <div className="mb-3">
    <TextField
          required
          className="form-control"
          label="Industry"
          value={Industry}
          onChange={e=> setIndustry(e.target.value)}
        />
      <ValidationMessage field="Industry" errors={validations}/>
      </div>
      <div className="mb-3">
      <TextField
          className="form-control"
          label="Address"
          value={Address}
          onChange={e=> setAddress(e.target.value)}
        />
        <ValidationMessage field="Address" errors={validations}/>
      </div>
      <div className="mb-3">
      <TextField
          className="form-control"
          label="User Limit"
          value={UserLimit}
          onChange={e=> setUserLimit(e.target.value)}
        />
        <ValidationMessage field="UserLimit" errors={validations}/>
      </div>
      <div className="mb-3">
      <div className="calendar-container">
      <label>Validity</label><br/>
      <DatePicker onChange={setValidityDate} value={ValidityDate} />
      </div>
      <ValidationMessage field="Name" errors={ValidityDate}/>
      </div>
      <div className="mb-3">
      <div className="form-check form-switch">
        <input className="form-check-input" type="checkbox" role="switch" checked={CanManageSituations ? "checked" : ""} onChange={e=> setCanManageSituations(e.target.checked)} />
        <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Allow deep analysis?</label>
      </div>
      </div>
      <div className="mb-3">
      <div className="form-check form-switch">
        <input className="form-check-input" type="checkbox" role="switch" checked={CanAccess ? "checked" : ""} onChange={e=> setCanAccess(e.target.checked)} />
        <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Allow access?</label>
      </div>
      </div>
      <div className="mb-3">
      <div className="form-check form-switch">
        <input className="form-check-input" type="checkbox" role="switch" checked={EnableVideos ? "checked" : ""} onChange={e=> setEnableVideos(e.target.checked)}/>
        <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Enable Video?</label>
      </div>
      </div>
        <div className="btns">
          <button type="button" className="btn btn-primary" onClick={handleSubmitClick} >Save</button>&nbsp;
          <a className="btn btn-secondary" onClick={handleCancelClick}>Cancel</a>
        </div>
      </form>
  )
}

export default CompanyEditor

